import COMMON_TYPES from '../../../actions/types';
import { getInsight } from '../../../api/amendment';

export const toggleInsightsLayer = params => {
  if(params && params.id) {
    return async dispatch => {
      try {
        dispatch({
          type: COMMON_TYPES.toggleLayer,
          payload: 'insights',
        });

        const result = await getInsight({ year: new Date().getFullYear() });

        dispatch({
          type: COMMON_TYPES.detailsGetResult,
          payload: result,
        });
      }
      catch (responseFail) {
        return dispatch({ type: COMMON_TYPES.detailsGetResultError });
      }
    }
  }

  return [
    { type: COMMON_TYPES.toggleLayer, payload: null },
    { type: COMMON_TYPES.detailsGetResult, payload: { data: null } }
  ];
};
